import { render, staticRenderFns } from "./DepositTable.vue?vue&type=template&id=5539418b&"
import script from "./DepositTable.vue?vue&type=script&lang=js&"
export * from "./DepositTable.vue?vue&type=script&lang=js&"
import style0 from "./DepositTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports